import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  Box,
  IconButton,
  TextField,
  Menu,
  MenuItem,
  Divider,
  Button,
  InputAdornment,
} from "@mui/material";
import { useOutletContext, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { esignToolApi } from "../../services/esignApi";
import { pdfToolApi } from "../../services/PdfEditor/pdfToolApi";
import { esignIcons } from "../Esign/icons";
import { getStatusStyles } from "../../heplers";
import { uploadDocument } from "../../store/reducers/uploadDocumentSlice";
import { apiEndpoint } from "../../urls";
import Loader from "../Loader";
import { refreshToken } from "../../store/reducers/pdfEditorTokenSlice";
import PdfPreview from "../PdfPreview/pdfPreview";
import TemplatesListView from "./templateListView";
import { useLogger } from "../../hooks/useLogger";

const Templates = () => {
  const logEvent = useLogger();
  const [documents, setDocuments] = useState([]);
  const [searchText, setSearchText] = useState("");
  const { open } = useOutletContext();
  const { profileData } = useSelector((state) => state.profile);
  const { pdfEditortoken } = useSelector((state) => state.pdfEditortoken);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [previewDocument, setPreviewDocument] = useState(false);
  const [listView, setListView] = useState(true);
  const [tileView, setTileView] = useState(false);
  const [previewDoc, setPreviewDoc] = useState({});

  useEffect(() => {
    fetchAllDocuments();
  }, []);

  const fetchAllDocuments = async () => {
    setLoader(true)
    try {
      const response = await esignToolApi.getTemplates();
      setLoader(false)
      if (response) {
        console.log(response)
        setDocuments(response.data);
      }
    } catch (error) {
      setLoader(false)
      console.error("Error fetching data:", error);
    }
  };

  const handleSearchChange = (event) => {
    logEvent('Clicked', 'Initiate Search', 'Documents/Template');
    setSearchText(event.target.value);
  };

  const filteredDocs = documents.filter(
    (doc) =>
      doc.document_name.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <>
      <Box sx={{ display: "flex", ml: "30px", mr: "30px", justifyContent: "space-between" }}>
        <TextField
          placeholder="Search..."
          type="text"
          variant="outlined"
          onChange={handleSearchChange}
          sx={{
          boxSizing: "border-box",
          borderRadius: "10px",
          backgroundColor: "#fff",
          borderColor: "#E8E8E9",
          borderWidth: "5px",
          "& .MuiOutlinedInput-root": {
              borderColor: "#E8E8E9",
              backgroundColor: "none",
              "&:hover fieldset": {
              borderColor: "#E8E8E9",
              },
              "&.Mui-focused fieldset": {
              borderColor: "#E8E8E9",
              },
          },
          "& .MuiFormHelperText-root": {
              color: "#FF6666",
          },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                {esignIcons.searchIcon}
              </InputAdornment>
            ),
            sx: { 
              borderRadius: "10px",
              width: 410,
              height: 40,
              fontSize: "16px",
              fontWeight: "500",
              "& input::-ms-reveal, & input::-ms-clear": {
                  display: "none",
              },
              "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                  display: "none",
                  WebkitAppearance: "none",
                  margin: 0,
              },
              "& input[type=number]": {
                  MozAppearance: "textfield",
              },
            },
          }}
        />
        {/* <Box sx={{ display: "flex", alignItems: "center", gap: "19px" }}>
            <Button variant="contained" sx={{ minWidth: 26, height: 26, background: "#FFFFFF", borderRadius: "8px", border: "none", boxShadow: "none", p:0, }} onClick={() => {setListView(true); setTileView(false);}} >
                {listView ? esignIcons.listViewIconActive : esignIcons.listViewIcon}
            </Button>
            <Button variant="contained" sx={{ minWidth: 26, height: 26, background: "#FFFFFF", borderRadius: "8px", border: "none", boxShadow: "none", p:0, }} onClick={() => {setListView(false); setTileView(true);}} >
                { tileView ? esignIcons.tileViewIconActive : esignIcons.tileViewIcon}
            </Button>
        </Box> */}
      </Box>
      {listView && (<TemplatesListView filteredDocs={filteredDocs} />)}
      {loader && <Loader />}
      {previewDocument && <PdfPreview previewDoc={previewDoc} setPreviewDoc={setPreviewDoc} previewDocument={previewDocument} setPreviewDocument={setPreviewDocument} />}
      </>
  );
};

export default Templates;
